@charset "UTF-8";

/* src/app/app.component.scss */
.splash.ios {
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 25000;
}
.splash {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  background-color: white;
  z-index: 25000;
}
@keyframes splash-fade {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.splash-faded.ios {
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: splash-fade 1s;
  background-color: white;
  z-index: 25000;
}
.splash-faded {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  animation: splash-fade 1s;
  background-color: white;
  z-index: 25000;
}
.help-ico {
  width: 16px;
}
.close-ico {
  font-size: 64px;
  --ionicon-stroke-width: 48px;
}
.help-bt {
  width: 45px;
  position: fixed;
  z-index: 3;
  bottom: 1rem;
  right: 1rem;
}
@keyframes blink {
  0%, 100% {
    border-color: #7af860;
  }
  50% {
    border-color: transparent;
  }
}
#blackSquare {
  width: 85%;
  height: 85.1%;
  background-color: #262626;
  opacity: 0.93;
  position: fixed;
  z-index: 1;
  left: 15%;
  bottom: 0%;
}
#squareCollections {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 5.5%;
  z-index: 10;
  left: 0%;
}
#squareAddCollection {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 12.5%;
  left: 0%;
  z-index: 10;
}
#squareAdminCollection {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 19.6%;
  z-index: 10;
  left: 0%;
}
#squareMessages {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 26.8%;
  left: 0%;
  z-index: 10;
}
#squareTradeClubs {
  position: absolute;
  width: 15%;
  height: 7%;
  left: 0%;
  top: 34%;
  z-index: 10;
}
#squarePreferences {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 41.2%;
  z-index: 10;
  left: 0%;
}
#squareNews {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 48.4%;
  left: 0%;
  z-index: 10;
}
#squareQR {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 55.6%;
  z-index: 10;
  left: 0%;
}
#squareHistory {
  position: absolute;
  width: 15%;
  height: 7%;
  top: 62.8%;
  z-index: 10;
  left: 0%;
}
#buttonClose {
  position: absolute;
  top: 86%;
  left: 36%;
  width: 27%;
  z-index: 1;
}
.helper-bt {
  position: absolute;
  top: 93%;
  left: 20.4%;
  width: 58%;
  z-index: 1;
  height: 3% !important;
}
.help-bg {
  background-color: var(--ion-color-primary);
  padding: 20px;
  border-radius: 10px;
  color: var(--ion-color-inverted-text);
  text-align: center;
  width: 90%;
  max-width: 490px;
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.help-bg-1 {
  border-radius: 10px;
  color: white;
  text-align: center;
  width: 90%;
  max-width: 490px;
  align-self: start;
  display: flex;
  flex-direction: column;
  background: rgba(var(--ion-color-helper-dark-bg-rgb), 0.6);
  gap: 0.5rem;
}
.helpText {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0vh;
  text-align: center;
  position: relative;
}
.helper-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(38, 38, 38, 0.93);
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: max-content;
  padding-bottom: 23px;
  display: block;
}
.helper-list {
  position: relative;
  top: 20px;
  left: 8px;
  background-color: rgba(38, 38, 38, 0);
  border-bottom: 0 !important;
}
.helper-list.ios {
  top: 0;
  left: 0;
}
.helper-list-item {
  --background: transparent;
  height: 56px;
  display: flex;
  align-items: center;
}
.helper-list-item.ios {
  --background: transparent;
  height: 50px;
  display: flex;
  align-items: center;
}
.helper-icon {
  background: white;
  padding: 7px;
  border-radius: 8px;
  position: relative;
  left: -7px;
}
.selected-icon {
  background: rgb(185, 232, 209);
  animation: blink 2s ease-in infinite;
}
@keyframes blink {
  from, to {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.helper-text-container {
  height: 495px;
  width: calc(100% - 58px);
  position: absolute;
  z-index: 2;
  top: 45px;
  right: 0;
  display: grid;
  justify-items: center;
  grid-template-rows: 1fr min-content 1fr;
}
ion-content.ios .helper-text-container {
  top: 20px !important;
  height: 450px !important;
}
ion-content {
  --padding-bottom: 0 !important;
}
.helper-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.helper-subtitle {
  font-size: 1.25rem;
  font-weight: bold;
}
.text {
  margin: 0;
}
.header-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(38, 38, 38, 0.93);
  z-index: 1;
}
.dev-theme-toggle {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 20px;
  border: 1px solid var(--ion-color-medium);
  background: var(--ion-color-background);
  color: var(--ion-color-text);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.dev-theme-toggle ion-icon {
  font-size: 1rem;
}
.app-shell {
  display: block;
  width: 100%;
  min-height: 100%;
  position: relative;
}
/*# sourceMappingURL=app.component.css.map */
